export enum SpecialAssistanceFormFields {
  ABLE_TO_SIT_WITH_KNEES_BENT = 'ableToSitWithKneesBent',
  ADD_MEDICAL_EQUIPMENT = 'addMedicalEquipment',
  ASSISTANT_NAME = 'assistantName',
  CAPAP_DEVICE_MODEL = 'CAPAPDeviceModel',
  DESTINATION = 'destination',
  LITHIUM_BATTERIES = 'lithiumBatteries',
  LITHIUM_BATTERY_1_POWER = 'lithiumBattery1Power',
  LITHIUM_BATTERY_2_POWER = 'lithiumBattery2Power',
  MEDA_ATTACHMENT = 'attachment',
  MEDICAL_CONDITION = 'medicalCondition',
  MEDICAL_EQUIPMENT = 'medicalEquipment',
  NEED_ASSISTANCE_WHERE = 'needAssistanceWhere',
  ORIGIN = 'origin',
  OTHER_MEDICAL_EQUIPMENT_MODEL = 'otherMedicalEquipmentModel',
  OTHER_MEDICAL_EQUIPMENT_TYPE = 'otherMedicalEquipmentType',
  OTHER_REASON = 'otherReasonForAssistance',
  OWN_WHEELCHAIR = 'ownWheelchair',
  PORTABLE_OXYGEN_CONCENTRATOR_MODEL = 'portableOxygenConcentratorModel',
  REASON_FOR_SPECIAL_ATTENTION = 'reasonForSpecialAttention',
  REASON_FOR_WHEELCHAIR = 'reasonForWheelchair',
  TRAVELING_WITH_ASSISTANT = 'travelingWithAssistant',
  WHEELCHAIR_DEPTH = 'wheelchairDepth',
  WHEELCHAIR_HEIGHT = 'wheelchairHeight',
  WHEELCHAIR_TYPE = 'wheelchairType',
  WHEELCHAIR_WEIGHT = 'wheelchairWeight',
  WHEELCHAIR_WIDTH = 'wheelchairWidth',
  OTHER_MOBILITY_AID_DESCRIPTION = 'otherMobilityAidDescription',
}
